export const API_SERVER = "https://api.karmacare.io";
// export const API_SERVER = "http://localhost:3000";
